export default [
  {
    path: '/reports',
    name: 'reports',
    component: () => import('@/views/reports/parcel/Report.vue'),
    meta: {
      pageTitle: 'Reports',
      permissions: ['view report'],
    },
  },
  {
    path: '/reports/customs-duty',
    name: 'reports-customs-duty',
    component: () => import('@/views/reports/customs-duty/Report.vue'),
    meta: {
      pageTitle: 'Customs duty report',
      permissions: ['view report'],
    },
  },
]
